import React, { useEffect, useState } from 'react';
import { Form, Input, Space } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAuth } from '@/contexts/auth';
import { Modal } from '@/components/Modal';
import { editWorkspace } from '@/services/workspace/api';
import { createNotification } from '../Notification';

export function EditWorkspaceModal({ open, onCancel, onSubmit, workspace }) {
  const { setWorkspaces } = useAuth();
  const intl = useIntl();
  const [form] = Form.useForm();
  const [submittable, setSubmittable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [values, form]);

  async function submit(values) {
    setIsSubmitting(true);

    await editWorkspace(workspace.external_id, values)
      .then(res => {
        createNotification(
          'success',
          intl.formatMessage({ id: 'modal.workspace.edit.success' }),
        );
        setWorkspaces(res.data.workspaces);
        onSubmit();
        form.resetFields();
      })
      .catch(() => {
        createNotification(
          'error',
          intl.formatMessage({ id: 'modal.workspace.edit.error' }),
        );
      })
      .finally(() => setIsSubmitting(false));
  }

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={intl.formatMessage({ id: 'modal.workspace.edit.title' })}
      />
      <Modal.Content align={'start'}>
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: 'flex',
          }}
        >
          <Form
            initialValues={{ name: workspace.name }}
            layout="vertical"
            form={form}
            onFinish={submit}
          >
            <Form.Item
              label="Workspace"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please input the name!',
                },
                { max: 20 },
              ]}
            >
              <Input
                placeholder={intl.formatMessage({
                  id: 'modal.workspace.edit.placeholder',
                })}
                required
                name="name"
                size="large"
              />
            </Form.Item>
          </Form>
        </Space>
      </Modal.Content>
      <Modal.Actions
        loading={isSubmitting}
        disabled={!submittable}
        submitText={<FormattedMessage id={'send'} />}
        onCancelAction={onCancel}
        onSubmitAction={form.submit}
      />
    </Modal.Root>
  );
}
